import normalize from '@disruptph/json-api-normalizer'
import Axios from 'axios'
import log from 'loglevel'
import { AXIOS_GET_TIMEOUT } from '.'
import { getApiRoot } from '../helpers/getApiRoot'
import { ApiResult } from '../interfaces/api'
import { authRefreshToken } from '../services/Auth'
import { getAccessToken, setAccessToken } from './accessToken'
import { errorCheckedReq } from './helpers/errorCheckedRequest'

const get = (endpoint: string) =>
  Axios.get(`${getApiRoot()}resources/${endpoint}`, {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    },
    timeout: AXIOS_GET_TIMEOUT
  })

export const apiGetResource = errorCheckedReq(async (endpoint: string) => {
    let response
    try {
      response = await get(endpoint)
    } catch (err) {
      if (Axios.isAxiosError(err) && err.response?.status === 401) {
        // Access token may just be stale (e.g. app resumed from background, or a freshly
        // issued token hitting a transient portal API propagation delay) rather than the
        // session actually being invalid - refresh and retry once before giving up.
        log.warn('apiGetResource: got 401, refreshing token and retrying once')
        const tokenResponse = await authRefreshToken()
        setAccessToken(tokenResponse.accessToken)
        response = await get(endpoint)
      } else {
        throw err
      }
    }
    return {
      result: ApiResult.SUCCESS,
      responseData: Object.assign({}, normalize(response.data))
    }
  })
